/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

function check(){
  alert('override');
  console.log('------------------');
}

/*
window.onload = function check(){

    //console.log(window.Shopify.theme.sections.instances[6].callStack)
    //window.Shopify.theme.sections.instances[6].callStack.onSelect()
  //  const test = document.getElementsByClassName("collection__sidebar");

*/
/*
  window.addEventListener('resize', function(event){
    if(normalviewbox()) {return blank; } 

      for(let i = 1; i < hold.children.length; i++){
        let temp = hold.children[i].style.left.slice(0, -1);
        hold.children[i].setAttribute('style', 'position: ' + 'absolute !important;'+ 'left: ' + basepercentage.toString +'%' + '!important');
        basepercentage = basepercentage + 87;
      }

  });
  */


function normalviewbox(){
    const test2 = document.getElementsByClassName("flickity-slider")
    const firstlvl = [...test2]
    const second = [...firstlvl]
    const hold = second[1]
    console.log(hold);
    var initialdx = parseInt(hold.children[0].style.left);
    //Below 28% is a magic number that is the width of the first item in the carousel
    return initialdx > 28;
}


  function customtranslatenext(){
    if(normalviewbox()){ return } 
     const slidercontainer = document.getElementsByClassName("flickity-slider")
     const translatestate = slidercontainer.style.transform + 87
     slidercontainer.setAttribute('style','transform: translateX('+translatestate+'px);');
  }

  function customtranslateprevious(){
    if(normalviewbox()){ return }
    const slidercontainer = document.getElementsByClassName("flickity-slider")
    const translatestate = slidercontainer.style.transform - 87
    slidercontainer.setAttribute('style','transform: translateX('+translatestate+'px);');
  }

    /*
    if(parseInt(hold.children[0].style.left) < 88){
    let temp = hold.children[0].style.left.slice(0, -1)
    var tempint = parseInt(temp)
 
      //console.log(temp)
      tempint = tempint + 80;
      console.log(tempint)
      //hold.children[2].style.left = tempint.toString +'% !important';
      //hold.children[0].removeAttribute('style');
      //hold.children[0].setAttribute('style', 'left: ' + '87% !important'); 
      hold.children[1].setAttribute('style', 'position: ' + 'absolute !important;'+ 'left: ' + '87% !important');
      hold.children[2].setAttribute('style', 'position: ' + 'absolute !important;'+ 'left: ' + '177% !important');
      hold.children[3].setAttribute('style', 'position: ' + 'absolute !important;'+ 'left: ' + '266% !important');
      hold.children[4].setAttribute('style', 'position: ' + 'absolute !important;'+ 'left: ' + '355% !important');
      hold.children[5].setAttribute('style', 'position: ' + 'absolute !important;'+ 'left: ' + '444% !important');
      hold.children[6].setAttribute('style', 'position: ' + 'absolute !important;'+ 'left: ' + '533% !important');
      hold.children[7].setAttribute('style', 'position: ' + 'absolute !important;'+ 'left: ' + '621% !important');
      
  

  }


/*
if(parseInt(hold.children[0].style.left) < 88){
    
    for(let i = 0; i < hold.children.length; i++){
      //hold.children[i].style.width = '100%'
      //console.log(hold.children[i].style.left)
      let temp = hold.children[i].style.left.slice(0, -1)
      var tempint = parseInt(temp) 
        //console.log(temp)
        tempint = tempint + 60;
        console.log(tempint)
        hold.children[i].removeAttribute('style');
        hold.children[i].style.left = tempint.toString +'% !important';
        hold.children[i].style.position = 'absolute';
        hold.children[i]('style', value);
      

    }
  }

  });
*/











var origAccordions = window.theme.accordions;
window.theme.accordions  = {
  onLoad() {
    sections$j[this.id] = new GlobalAccordions(this);
    sections$j[this.id].onSelect();

  },
  onSelect() {
    sections$j[this.id].onSelect();
  },
  onDeselect() {
    sections$j[this.id].onDeselect();
  },
  onBlockSelect(e) {
    sections$j[this.id].onBlockSelect(e);
  },
  onBlockDeselect(e) {
    sections$j[this.id].onBlockDeselect(e);
  },
};